module.exports = __webpack_public_path__ + "media/jindu.573d26cd.mp4";